import type { InfiniteWarState, IwTeam } from "./types";

/** Regen mana available to spend (soul bank removed). */
export function spendableMana(state: InfiniteWarState, team: IwTeam): number {
  return state.mana[team];
}

export function canAfford(state: InfiniteWarState, team: IwTeam, cost: number): boolean {
  return spendableMana(state, team) >= cost;
}

/** Spend from regen mana only. Cap clamping stays on tick. */
export function spendMana(state: InfiniteWarState, team: IwTeam, cost: number): boolean {
  if (!canAfford(state, team, cost)) return false;
  state.mana[team] -= cost;
  return true;
}
